import { BaseQualityItem } from '../types/baseQualityItem';

export const designControlStatus = (item: Pick<BaseQualityItem, 'changeControlStatus' | 'itemStatus'>): string => {
  if (item.changeControlStatus === 'unstaged' || !item.changeControlStatus) {
    return item.itemStatus || '';
  }

  return item.changeControlStatus === 'staged' ? 'In Review' : 'Approved';
};
